import {Checkout} from "@connox/typescript-library";
import React, {useState} from "react";
import Spinner from "../../utils/loader/Spinner";
import {Button, ButtonStyles, ButtonType} from "../form/Button/Button";
import {IPaymentModule, IPurchaseButtonProps} from "./IPaymentModule";
import {PaymentController, Payments} from "./PaymentController";

export default class DefaultPaymentModule implements IPaymentModule {
  public readonly title = "Default Payment";

  constructor(readonly checkout: Checkout) {
    this.PurchaseButton = this.PurchaseButton.bind(this) as (props: IPurchaseButtonProps) => React.ReactElement;
  }

  public PurchaseButton(props: IPurchaseButtonProps): React.ReactElement {
    const [visible, setVisible] = useState<boolean>(true);
    const {handleError, label} = props;

    const actionMethod = async () => {
      setVisible(false);
      try {
        await PaymentController.authorizePayment();
        await this.checkout.purchase();
      } catch (err) {
        setVisible(true);
        handleError(err);
      }
    };

    const spinner = React.createElement(Spinner, {}, null);

    return React.createElement(
      Button,
      {action: actionMethod, styles: [ButtonStyles.wide], type: visible ? ButtonType.default : ButtonType.disabled},
      visible ? label : spinner,
    );
  }

  public async onSubmitPayment(): Promise<boolean> {
    return Promise.resolve(true);
  }

  public async onEnterSummary(): Promise<void> {
    if (this.checkout.paymentId !== Payments.PaypalExpressBraintree && this.checkout.paymentId !== Payments.AmazonPay) {
      await PaymentController.initPayment();
    }
  }

  public async onPaymentSelect(): Promise<void> {
    return Promise.resolve();
  }

  public isDataComplete(): boolean {
    return true;
  }
}
